var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", 
    label: "Unique ID", 
    type: types.INPUT ,
    tab_size:10,
  },

  {
    id: "mail_message_number",
    label: "メールメッセージ番号",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      mail_message: "A"
    },
  },
  {
    id: "mail_type",
    label: "メール区分",
    type: types.INPUT,
    type: types.SELECT_BOX,
    tab_size:15,
    options: [
      "個別連絡事項",
      "通達",
      "ID申請",
    ],
    export: { 
      enabled: true,
      sequence: 1000,
      mail_message: "B"
    },
  },
  {
    id: "mail_subject",
    label: "メールタイトル",
    type: types.INPUT,
    tab_size:60,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      mail_message: "C"
    },
  },
  {
    id: "mail_content",
    label: "メール本文",
    type: types.TEXT_AREA,
    tab_size:100,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      mail_message: "D"
    },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_mail_message.js